import { Route, Switch } from "wouter";
import Login from "../pages/auth/Login";
import CfxreCallback from "../pages/auth/CfxreCallback";
import AddMasterPin from "../pages/auth/AddMasterPin";
import AddMasterCallback from "../pages/auth/AddMasterCallback";
import { Card } from "../components/ui/card";
import { Wordmark } from "@/components/Logos";
import { useThemedImage } from "@/hooks/theme";
import { AuthError } from "@/pages/auth/errors";
import { Diamond, Hairline } from "@/components/Ornaments";

function AuthContentWrapper({ children }: { children: React.ReactNode }) {
    return (
        <div className="flex min-h-80 flex-1 flex-col justify-center text-center">
            {children}
        </div>
    );
}


export default function AuthShell() {
    const customLogoUrl = useThemedImage(window.txConsts.providerLogo);
    return (
        <div className="min-h-screen flex items-center justify-center pattern-dots">
            <div className="w-full min-w-[20rem] xs:max-w-[25rem] my-4 xs:mx-4">
                {customLogoUrl ? (
                    <img
                        className='max-w-36 xs:max-w-56 max-h-16 xs:max-h-24 m-auto'
                        src={customLogoUrl}
                        alt={window.txConsts.providerName}
                    />
                ) : (
                    <Wordmark size="lg" className="justify-center" />
                )}

                <Card className="mt-3 xs:mt-5 mb-4 flex flex-col rounded-none xs:rounded-hud">
                    <Switch>
                        <Route path="/login">
                            <Login />
                        </Route>
                        <Route path="/login/callback">
                            <AuthContentWrapper>
                                <CfxreCallback />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/addMaster/pin">
                            <AuthContentWrapper>
                                <AddMasterPin />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/addMaster/callback">
                            <AuthContentWrapper>
                                <AddMasterCallback />
                            </AuthContentWrapper>
                        </Route>
                        <Route path="/:fullPath*">
                            <AuthContentWrapper>
                                <AuthError
                                    error={{
                                        errorTitle: '404 | Not Found',
                                        errorMessage: 'Something went wrong.',
                                    }}
                                />
                            </AuthContentWrapper>
                        </Route>
                    </Switch>
                </Card>


                <div className="flex items-center justify-center gap-1.5">
                    <Hairline direction='left' />
                    <span className="shrink-0 font-highlight text-micro uppercase tabular tracking-[.14em] text-faint scrim">
                        tx v{window.txConsts.txaVersion} &middot; fx b{window.txConsts.fxsVersion}
                    </span>
                    <Diamond />
                </div>
            </div>
        </div>
    );
}
